module.exports = __webpack_public_path__ + "static/1-b3d6621b34e005cc9f532734e5f1ef94.jpg";